import { render, staticRenderFns } from "./EditVesselPage.vue?vue&type=template&id=418788ca&"
import script from "./EditVesselPage.vue?vue&type=script&lang=js&"
export * from "./EditVesselPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports